module.exports = __webpack_public_path__ + "static/media/Manual_sencer_EN-12.2963e5a1.png";